import { useEffect, useState } from 'react'
import { fetchCrmMe } from '../workspace/api'

let me: Promise<{ id: string; username: string } | null> | null = null

/** The signed-in person as the CRM knows them (one request per page load). */
export function useCrmMe(): { id: string; username: string } | null | undefined {
  const [value, setValue] = useState<{ id: string; username: string } | null | undefined>(undefined)
  useEffect(() => {
    let live = true
    me ??= fetchCrmMe().catch(() => null)
    void me.then((m) => {
      if (!m) me = null
      if (live) setValue(m)
    })
    return () => {
      live = false
    }
  }, [])
  return value
}
